import { editDynamicPageUrlStructurePanel as editDynamicPageUrlStructurePanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { AppApi } from '@wix/wix-data-client-common'

export const openEditDynamicPageUrlStructurePanel = async ({
  editorSdkProxy,
  hostname,
  initialData,
}: {
  editorSdkProxy: EditorSDK
  hostname: string
  initialData: Parameters<AppApi['openEditDynamicPageUrlStructurePanel']>[0]
}) => {
  return await editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: editDynamicPageUrlStructurePanelDef.url,
      editorSdkProxy,
    }),
    initialData,
    width: 600,
    height: 330,
    shouldHideHeader: true,
  })
}
